import { Controller } from 'react-hook-form';
import { useTranslation } from 'next-i18next';
import { Spacing } from '@zep/ui';
import { RadioGroup, RadioGroupItem } from '@zep/ui/experimental';
import { OperationType } from '../../../../../types';
import { usePlanPricing } from '../../hooks';
import { usePlanPaymentFormContext, usePlanPaymentInfoContext } from '../../PlanPaymentSection/Providers';
import { PlanTemplateType } from '../../types';
import { DiscountBadge } from './shared/DiscountBadge';
import { PaymentTypeText } from './shared/PaymentTypeText';
import { PriceTextInLabel } from './shared/PriceTextInLabel';
import { PlanNotiText, PlanRadioLabel } from './shared';
export const SubscriptionTabsContent = () => {
  const {
    t
  } = useTranslation(['subscription']);
  const {
    formState: {
      defaultValues
    },
    control,
    watch
  } = usePlanPaymentFormContext();
  const {
    prices,
    currentOperationType,
    planPaymentInfo,
    isUpdate,
    currencyString
  } = usePlanPaymentInfoContext();
  const planType = watch('planType');
  const maxCcu = watch('maxCcu');
  const planTemplateType = watch('planTemplateType');
  const {
    monthlySaleRate,
    finalMonthlyPrice,
    yearlySaleRate,
    finalYearlyPrice,
    monthlyPrice,
    yearlyPrice
  } = usePlanPricing({
    planType,
    prices,
    maxCcu
  });

  // 현재 연간정기플랜을 사용 중일 땐 월간 결제 선택이 불가능하다.
  const is연간정기 = currentOperationType === OperationType.정기 && planPaymentInfo?.subscription?.subscriptionPeriod === 365;
  const subscriptionPeriod = watch('subscriptionPeriod');
  return <Controller control={control} name="subscriptionPeriod" render={({
    field
  }) => {
    return <>
            <RadioGroup disabled={currentOperationType === OperationType.일시납} defaultValue={subscriptionPeriod ?? String(defaultValues?.subscriptionPeriod)} onValueChange={field.onChange} className="flex w-full flex-col gap-[8px]">
              {is연간정기 ? null : <PlanRadioLabel highlighted={subscriptionPeriod === '30'}>
                  <div className="flex items-center gap-[8px]">
                    <RadioGroupItem id="30" value="30" />
                    <PaymentTypeText text={t('subscription:payment.duration.monthly', '월간 결제')} className={subscriptionPeriod === '30' ? 'font-[700] text-primary' : ''} />
                    {monthlySaleRate > 0 && <DiscountBadge discountRate={monthlySaleRate} />}
                  </div>
                  <div className="flex flex-1 justify-end">
                    <PriceTextInLabel currencyString={currencyString} discountRate={monthlySaleRate} originalPrice={monthlyPrice} finalPrice={finalMonthlyPrice} suffix={t('subscription:payment.duration.discountPerPerson', '/ 월(1인)')} highlighted={subscriptionPeriod === '30'} />
                  </div>
                </PlanRadioLabel>}
              <PlanRadioLabel highlighted={subscriptionPeriod === '365'}>
                <div className="flex items-center gap-[8px]">
                  <RadioGroupItem id="365" value="365" />
                  <PaymentTypeText text={t('subscription:payment.duration.annual', '연간 결제')} className={subscriptionPeriod === '365' ? 'font-[700] text-primary' : ''} />
                  {yearlySaleRate > 0 && <DiscountBadge discountRate={yearlySaleRate} />}
                </div>
                <div className="flex flex-1 justify-end">
                  <PriceTextInLabel currencyString={currencyString} discountRate={yearlySaleRate} originalPrice={yearlyPrice} finalPrice={finalYearlyPrice} suffix={t('subscription:payment.duration.discountPerPerson', '/ 월(1인)')} highlighted={subscriptionPeriod === '365'} />
                </div>
              </PlanRadioLabel>
            </RadioGroup>
            {isUpdate && planTemplateType === PlanTemplateType.PRODUCT_SUBSCRIPTION && <>
                  <Spacing size={14} />
                  <PlanNotiText alertText={t('subscription:payment.planTabs.alertUpgradePlan', '정기 결제 중에는 일시납 결제로 변경이 불가능합니다')} />
                </>}
          </>;
  }} data-sentry-element="Controller" data-sentry-component="SubscriptionTabsContent" data-sentry-source-file="SubscriptionTabsContent.tsx" />;
};